import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Icon } from 'components/common/icons';

import type { ReaderSettings } from 'shared-types';
import type { IconProp } from 'components/common/icons/Icon';

const ReaderCompletionNotification = ({
  children,
  description,
  descriptionStyle,
  icon,
  iconStyle,
  style
}: {
  children?: React.ReactNode;
  description: string;
  descriptionStyle?: React.CSSProperties;
  icon: IconProp;
  iconStyle?: React.CSSProperties;
  style?: React.CSSProperties;
}) => {
  const {
    pageState: { presentMode, settings, settingsPresentMode },
    theme
  } = useReduxState();

  const currentSettings =
    (presentMode ? settingsPresentMode : settings) || ({} as ReaderSettings);

  return (
    <div
      className="notification"
      style={{
        fontSize: {
          small: '1.3rem',
          medium: '1.4rem',
          large: '1.5rem',
          huge: '1.8rem'
        }[currentSettings.fontSize],
        ...style
      }}
    >
      <div className="icon" style={iconStyle}>
        <Icon icon={icon} />
      </div>
      <div className="description" style={descriptionStyle}>
        {description}
      </div>
      <div className="action">{children}</div>

      <style jsx>{`
        .notification {
          align-items: center;
          background-color: ${theme.lightGrey};
          border-radius: ${theme.cardBorderRadius};
          color: ${theme.textColorLighter};
          display: flex;
          flex-wrap: wrap;
          font-weight: 600;
          padding: 10px 15px;
        }
        .icon {
          margin-right: 7px;
          position: relative;
        }
        .description {
          flex-grow: 1;
          flex-shrink: 1;
          min-width: 0;
        }
        .action {
          margin-top: 10px;
        }
        @media (min-width: ${breakpoints.small}px) {
          .notification {
            flex-wrap: nowrap;
          }
          .action {
            margin-top: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ReaderCompletionNotification;
